import { Component } from '@angular/core';
import { RouterOutlet, Router, Event, NavigationEnd, NavigationStart } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { removeSessionItem } from './shared/utils';
import { AuthService } from './shared/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'cims-auth-ui';

  constructor(private router: Router, private idle: Idle, private authService: AuthService) {
    this.setupIdleTimeout();
  }

  ngOnInit() {
    this.authService.validateToken();

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.authService.validateToken();
      }
      if (event instanceof NavigationEnd) {
        setTimeout(() => window.HSStaticMethods.autoInit(), 100);
      }
    });
  }

  setupIdleTimeout() {
    this.idle.setIdle(21600); // 5 minutes of inactivity
    this.idle.setTimeout(2); // After 2 seconds of timeout, log out

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.onTimeout.subscribe(() => {

      removeSessionItem('accessToken');
      removeSessionItem('userAccount');
      
      this.router.navigate(['/signin']); // Redirect to login
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.idle.watch();
    });

    this.idle.watch(); // Start watching for idle
  }

}
